var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-wrap" },
    [
      _c(
        "el-upload",
        _vm._g(
          _vm._b(
            {
              ref: "elUpload",
              class: { "hide-upload-holder": _vm.hideUpload },
              attrs: {
                action: _vm.getUploadUrl,
                headers: _vm.getUploadHeader,
                "auto-upload": true,
                multiple: true,
                limit: _vm.limitCount,
                accept: _vm.acceptType.join(","),
                "file-list": _vm.fileList,
                listType: _vm.listType,
                "on-preview": _vm.picCardPreview,
                "before-upload": _vm.beforePicUpload,
                "on-remove": _vm.removePic,
                "on-progress": _vm.uploadOnProgress,
                "on-error": _vm.uploadError,
                "on-success": _vm.uploadPicSuccess,
                "on-exceed": _vm.handleExceed,
              },
            },
            "el-upload",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm.listType === "picture-card"
            ? _c(
                "div",
                {
                  staticClass: "el-icon-plus",
                  staticStyle: { color: "#409eff" },
                  attrs: { slot: "default" },
                  slot: "default",
                },
                [_vm._v("上传图片")]
              )
            : _vm._e(),
          _vm.listType === "text" ? _vm._t("btn") : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: { "append-to-body": "", visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [_c("img", { attrs: { width: "100%", src: _vm.dialogImageUrl } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }